import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const RibKnitVest = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.RibKnitVest.itemName}
      name={SS23.tops.RibKnitVest.itemName}
      price={SS23.tops.RibKnitVest.itemPrice}
      fabric={SS23.tops.RibKnitVest.itemFabric}
      src={SS23.tops.RibKnitVest.sizeChart}
      divId={SS23.tops.RibKnitVest.shopifyDivId}
      mainId={SS23.tops.RibKnitVest.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.RibKnitVest.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.RibKnitVest.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default RibKnitVest;
